class NotificationService {
  public isBrowserCompatible(): boolean {
    const isCompatible = !!('Notification' in window);

    if (!isCompatible) {
      console.log('Notification is not supported by the browser');
    }

    return isCompatible;
  }

  public requestPermission() {
    if (!this.isBrowserCompatible()) return;

    return Notification.requestPermission();
  }

  private send(title: string, text: string) {
    if (!this.isBrowserCompatible()) return;
    /* eslint-disable @typescript-eslint/no-unused-vars */
    const notification = new Notification(title, {
      body: text,
      icon: 'assets/images/logo.svg'
    });
  }

  public notifyUploadStart() {
    this.send(
      'Envio de vistorias iniciado',
      'Identificamos uma conexão estável e o envio das vistorias foi iniciado');
  }

  public notifyUploadStatus(description: string) {
    this.send(
      'Envio de vistorias iniciado',
      description);
  }

  public notifyUploadStoped() {
    this.send(
      'Envio de vistorias pausado',
      'Não identificamos uma conexão estável, por isso o envio das fotos foi pausado.');
  }

  public notifyUploadFinished() {
    this.send(
      'Envio de vistorias concluído',
      'As vistorias foram recebidas e estão sendo analisadas. Em breve, entraremos em contato');
  }
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new NotificationService();
